/************
 Swipers
 ************/

// thumbnails mobile
let productV28ThumbnailImages = new Swiper("#productV28ThumbnailsSwiper", {
    slidesPerView: "auto",
    spaceBetween: 5,
    breakpoints: {
        800: {
            slidesPerView: 6,
        }
    },
    loop: true,
    navigation: {
        nextEl: '#productV28ThumbnailsNext',
        prevEl: '#productV28ThumbnailsPrev',
    },
});

// main swiper
let productV28Images = new Swiper("#productV28Swiper", {
    navigation: {
        nextEl: '#productV28Swiper .productV28SwiperNext',
        prevEl: '#productV28Swiper .productV28SwiperPrev',
    },
    loop: true,
    thumbs: {
        swiper: productV28ThumbnailImages
    }
});

// gallery desktop
document.querySelectorAll(".productV28GalleryItem").forEach(function (element) {
    element.addEventListener("click", function () {
        // determine index
        let index = getElIndex(this);

        // change active slide
        productV28Images.slideTo(index);
    });
});

/********************
 Video Popup
 *******************/

// open video
document.querySelectorAll('.productV28Video')?.forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        const popup = document.querySelector(".videoPopup");
        popup.showModal();

        // check if we're on mobile and if .videoPopupVideo.mobileOnly exists
        if (window.innerWidth < 800 && popup.querySelector(".videoPopupVideo.mobileOnly")) {
            popup.querySelector(".videoPopupVideo.mobileOnly").play();
        } else {
            popup.querySelector("video").play();
        }
    })
})


/*****************
 Reviews
 ****************/

document.querySelector("#productV28Review")?.addEventListener("click", function () {
    window.scrollTo({
        top: document.querySelector("#looxReviews").offsetTop - 100,
        behavior: "smooth"
    });
})


/**************
 Function To Update Pricing
 ***************/

// cache the first images to swap later
const ogFirstImages = {
    desktop: document.querySelector('.productV28SwiperSlideImage').src,
    mobile: document.querySelector('.productV28ThumbnailsSwiperSlide').src,
    gallery: document.querySelector('.productV28GalleryItem').src
}

// update active variant
function updateProductV16(skipImage = false) {

    // if custom product input is checked, we use a different product
    product = defaultProduct;
    if (document.querySelector('.productV28OptionLabelInput:checked').value === "custom") {
        product = customProduct
    }

    // check for an active color swatch
    activeVariant = product.variants.filter((variant) => {
        return variant.title === document.querySelector(".productV28FormGroupFlexColor:checked").value
    })[0];

    // find variant image
    if (!skipImage) {

        // if the custom product is selected, slide to first slide AND replace image with first custom product image
        if (document.querySelector('.productV28OptionLabelInput:checked').value === "custom") {
            // swap first images
            document.querySelector('.productV28SwiperSlideImage').src = customProduct.media[0].src;
            document.querySelector('.productV28ThumbnailsSwiperSlide').src = customProduct.media[0].src;
            document.querySelector('.productV28GalleryItem').src = customProduct.media[0].src;

            // slide to first image
            productV28Images.slideTo(0);

        } else {

            // swap first images
            document.querySelector('.productV28SwiperSlideImage').src = ogFirstImages.desktop;
            document.querySelector('.productV28ThumbnailsSwiperSlide').src = ogFirstImages.desktop;
            document.querySelector('.productV28GalleryItem').src = ogFirstImages.gallery;

            if (activeVariant.featured_image) {
                const variantImage = document.querySelector(`.productV28SwiperSlide[id="${activeVariant.featured_image.id}"]`);
                if (variantImage) {
                    productV28Images.slideTo(getElIndex(variantImage));
                }
            }
        }
    }

    // in the variant available?
    let isAvailable = activeVariant.available;

    // check if the variant is in stock
    if (isAvailable) {
        document.querySelector("#productV28ATC").classList.remove("oos");
        document.querySelector("#productV28ATC").textContent = `Add To Cart`;
    } else {
        document.querySelector("#productV28ATC").classList.add("oos");
        document.querySelector("#productV28ATC").textContent = "Sold Out — Notify Me When Available";
    }
}

updateProductV16(true)

/*******************
 Product Form (Default and Group)
 ********************/

// color swatch support on change
document.querySelectorAll(".productV28FormGroupFlexColor").forEach(function (element) {
    element.addEventListener("change", function () {
        // update label
        this.parentElement.parentElement.parentElement.querySelector(".productV28FormGroupHeaderLabel").innerHTML = this.getAttribute("aria-label");

        // update price
        updateProductV16();
    });
});

document.querySelectorAll('.productV28OptionLabelInput').forEach(function (element) {
    element.addEventListener("change", function () {
        updateProductV16();
    })
})


// variant dropdown support on change
document.querySelector("#productV28FormVariants")?.addEventListener("change", updateProductV16);


/****************
 *  Quantity
 *************/

let quantity = 1;


/**************
 Product ATC
 ***************/

// add to cart button
document.querySelector("#productV28ATC").addEventListener("click", async function (e) {
    e.preventDefault();

    // check for out of stock
    if (this.classList.contains("oos")) {
        // check email
        let {value: email} = await Swal.fire({
            title: product.title,
            text: "Enter your email to be notified when this product is back in stock.",
            input: "email",
            inputPlaceholder: "Email Address",
            confirmButtonText: "Notify Me When Available",
        });

        // confirm email is returned
        if (!email) {
            return;
        }

        // add to waitlist
        let formData = new FormData();
        formData.append("a", await klaviyo.account());
        formData.append("email", email);
        formData.append("g", "");
        formData.append("variant", activeVariant.id);
        formData.append("product", product.id);
        formData.append("platform", "shopify");
        formData.append("subscribe_for_newsletter", false);
        fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", {
            method: "POST",
            body: formData
        })

        // show success message
        await Swal.fire({
            title: "Success!",
            text: "You will be notified when this product is back in stock.",
            confirmButtonText: "OK",
        });

        return;
    }

    // add loading animation
    this.classList.add("loading");

    // create form data
    let formData = {
        items: []
    };


    // normal product
    formData.items.push({
        quantity: quantity,
        id: activeVariant.id,
    });


    // reverse form data
    formData.items.reverse();

    // check if we should go directly to checkout
    if (this.classList.contains('checkout')) {

        // clear cart
        await clearCart();

        await addProduct(formData)

        window.location.href = '/checkout';

        // klaviyo tracking
        try {
            _learnq.push(['track', 'Added to Cart', item]);
        } catch (error) {
            console.error("Klaviyo tracking not found");
        }

        return;
    }

    // add productV28
    await addProduct(formData);

    // klaviyo tracking
    try {
        _learnq.push(['track', 'Added to Cart', item]);
    } catch (error) {
        console.error("Klaviyo tracking not found");
    }

    // remove loading animation
    this.classList.remove("loading");

    // open cart
    await openCart();
});


// atc call to action
document.querySelectorAll(`.button[href="#add_to_cart"]`).forEach(function (element) {
    element.addEventListener("click", async function (e) {
        e.preventDefault();

        // click normal atc
        document.querySelector("#productV28ATC").click();

        // start/stop loading
        this.classList.add("loading");
        await sleep(1000);
        this.classList.remove("loading");
    });
});

// atc call to action
document.querySelectorAll(`.button[href="#add_to_cart_addon"]`).forEach(function (element) {
    element.addEventListener("click", async function (e) {
        e.preventDefault();

        // check the addon if not already checked
        if (!document.querySelector("#productV28AddonCheckboxInput").checked) {
            document.querySelector("#productV28AddonCheckbox").click();
        }


        // click normal atc
        document.querySelector("#productV28ATC").click();

        // start/stop loading
        this.classList.add("loading");
        await sleep(1000);
        this.classList.remove("loading");
    });
});

/**************
 Sticky ATC
 ***************/

const stickyAtcObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
        if (entry.isIntersecting) {
            document.querySelector("#productV28ATC").classList.remove("sticky");
        } else {
            document.querySelector("#productV28ATC").classList.add("sticky");
        }
    });
}, {
    rootMargin: "-100px 0px 0px 0px"
})

stickyAtcObserver.observe(document.querySelector("#productV28Content"));

// event listeners for dropdown items
document.querySelectorAll(`.productV28DropdownTop`).forEach(function (element) {
    element.addEventListener("click", function () {
        this.parentElement.classList.toggle("active");
    });
});

/**************
 Shipping Time
 ***************/

// Consistent random number generation using the hash as a seed
function generateSeededRandom(key, min, max) {
    let hash = 0;
    for (let i = 0; i < key.length; i++) {
        hash = (hash << 5) - hash + key.charCodeAt(i);
        hash |= 0;
    }

    const x = Math.sin(hash) * 10000;
    const seed = x - Math.floor(x);

    return Math.floor(seed * (max - min + 1) + min);
}

let ordersRemaining = localStorage.getItem('ordersRemaining');

// check local storage for orders remaining and set
if (ordersRemaining && localStorage.getItem('productHandle') === product.handle) {
    if (document.querySelector('#productV28ShippingRemainingTxt')) {
        document.querySelector('#productV28ShippingRemainingTxt').textContent = `${ordersRemaining} orders remaining`;
    }
} else {
    // generate random number and set local storage if not found
    ordersRemaining = generateSeededRandom(product.handle, 10, 100);
    localStorage.setItem('ordersRemaining', ordersRemaining);
    localStorage.setItem('productHandle', product.handle);

    if (document.querySelector('#productV28ShippingRemainingTxt')) {
        document.querySelector('#productV28ShippingRemainingTxt').textContent = `${ordersRemaining} orders remaining`;
    }
}

// show shipping tomorrow
let date = new Date();
date.setDate(date.getDate() + 1);
date = date.toLocaleDateString('en-US', {month: 'short', day: 'numeric'});
document.querySelector('#productV28ShippingDateTxt').innerHTML = `Ships <strong>Tomorrow, ${date}</strong>`;


// check local storage for orders remaining and set
if (ordersRemaining && localStorage.getItem('productHandle') === product.handle) {
    document.querySelector('#productV28ShippingRemainingTxt').textContent = `${ordersRemaining} orders remaining`;
} else {
    // generate random number and set local storage if not found
    ordersRemaining = generateSeededRandom(product.handle, 10, 100);
    localStorage.setItem('ordersRemaining', ordersRemaining);
    localStorage.setItem('productHandle', product.handle);
    document.querySelector('#productV28ShippingRemainingTxt').textContent = `${ordersRemaining} orders remaining`;
}


// open productV28Popup dialog
document.querySelectorAll('.openVideo')?.forEach(function (element) {
    element.addEventListener('click', function () {
        document.querySelector(".productV28Popup").showModal();
        document.querySelector("body").classList.add("noScroll");

        // play video
        document.querySelector(".productV28PopupVideo")?.play();


    });
})

// close productV28Popup
function closePopup() {
    document.querySelector(".productV28Popup")?.close();
    document.querySelector("body").classList.remove("noScroll");

    // pause video and reset time
    document.querySelector(".productV28PopupVideo")?.pause();

}

// close productV28Popup event listener
document.querySelectorAll(".productV28PopupBodyHeaderClose")?.forEach(function (element) {
    element.addEventListener("click", closePopup);
});

document.querySelector(".productV28Popup")?.addEventListener("click", function (e) {
    if (e.target === this) {
        closePopup();
    }
})

// close event
document.querySelector(".productV28Popup")?.addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});